import type { InquiryStepDefinition } from '../../types';
import { CustomerCountQuestion } from './CustomerCountQuestion';
import { CustomerCountSummary } from './CustomerCountSummary';

export const PARTY_SIZE: InquiryStepDefinition = {
  stepName: 'PARTY_SIZE',
  component: CustomerCountQuestion,
  summaryComponent: CustomerCountSummary,
  fieldNames: ['serviceCustomerCount', 'flexibleOnServiceCustomerCount'],
  isOptional: false,
  tabIndex: 0,
  slug: 'party-size',
  isAnswered: ({ initialValues }) => {
    return Boolean(initialValues.serviceCustomerCount);
  },
};
